import { Layout } from 'antd';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { ROUTES } from '../common/constants';
import './app.less';
import AppHeader from './components/header/AppHeader';
import UserProfile from './components/header/UserProfile';

//Image Import
import { AppContext } from '../AppContext';
import LOGO from '../assets/images/main-logo.png';
import { RoutePromptContext } from '../RoutePromptContext';
import { AppContextType } from '../types/appContext.type';

const { Content } = Layout;

const App = () => {
  const routePromptContext = useContext(RoutePromptContext);
  const {
    state: { routerPrompt },
  } = useContext(AppContext) as AppContextType;
  if (!routePromptContext) return null;
  const { handleNavigationAttempt } = routePromptContext;
  const handleLogoClick = () => {
    if (location.pathname !== ROUTES.MAIN) {
      handleNavigationAttempt(ROUTES.MAIN, routerPrompt);
    }
  };

  return (
    <Layout hasSider>
      <Layout className="site-layout">
        <div className="justify-around">
          <AppHeader>
            <div className="header-wrapper">
              <img
                src={LOGO}
                alt="logo"
                className="main-logo"
                onClick={handleLogoClick}
              ></img>
              <div>
                <UserProfile />
                <div />
              </div>
            </div>
          </AppHeader>
        </div>
        <Content className="wrapper">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
